export function handleSubmit({ subject, body, sendEmail, handleClose, contactId }) {
  const payload = {
    type: 'collegeContact',
    contactId,
    subject,
    text: body,
  };

  const callback = () => handleClose();

  sendEmail(payload)
    .then(callback)
    .catch(callback);
}

export function parseContactData(contact) {
  const { email, phone, hidePhoneOnFc, fax } = contact;
  return {
    email: {
      value: email,
    },
    phoneNumber: {
      value: hidePhoneOnFc ? '' : phone,
    },
    fax: {
      value: fax,
    },
  };
}
